import Vue from 'vue'

// 请求成功状态处理
export const catchResponse = function (res) {
  switch (res.status) {
    case 0:
      return res
    case 2:
      if (res.data && res.data.jumpUrl) {
        window.location.href = res.data.jumpUrl
      } else {
        window.location.href = '/#/login'
      }
      return false
    default:
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        Vue.prototype.$toast.text(res.msg || '服务端异常，请联系技术支持')
      } else {
        Vue.prototype.$message({
          message: res.msg || '服务端异常，请联系技术支持',
          type: 'error'
        })
      }
      return false
  }
}
// 服务器/网络错误处理
export const catchError = function (error) {
  if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
    Vue.prototype.$toast.text('数据请求失败，请检查网络是否已连接')
  } else {
    Vue.prototype.$message({
      message: '数据请求失败，请检查网络是否已连接',
      type: 'error'
    })
  }
  return Promise.reject(error)
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js